import { Link } from "@quintype/components";
import React from "react";
import PropTypes from "prop-types";
import { useScrollLock } from "../helper/hooks";
import SubscriptionNudge from "../../../assets/images/nl-images/stopnudge1.png";
import logo from "../../../assets/images/newslaundry_logo.png";
import assetify from "@quintype/framework/assetify";

import { FaTimes } from "react-icons/fa";
import "./subscription-appeal-banner.m.css";

const SubscriptionAppealBanner = ({ setToShowPopup }) => {
  const isHindi = !!(global.location && global.location.host.includes("hindi"));

  useScrollLock();

  return (
    <div styleName="wrapper">
      <div styleName="left-container">
        <img
          src={assetify(SubscriptionNudge)}
          alt="subscription-appeal-image"
          styleName="subscription-appeal-image"
        />
      </div>
      <div styleName="middle-container">
        <div styleName="row-wrapper">
          <div styleName="logo-wrapper">
            <img src={assetify(logo)} alt="newslaundry logo" />
          </div>
          <h1 styleName="text-container">
            <span>Support Independent Media</span>
          </h1>
        </div>
        <div styleName="appeal-wrapper">
          <p styleName="appeal-text">
            {isHindi
              ? "एक स्वतंत्र मीडिया जिन सवालों के जवाब मिलने चाहिए उन सवालों को पूछ कर जनतंत्र को थामे रखता है, जिन कहानियों को कहना जरूरी है उन्हें कह कर उसे बचाए रखता है. स्वतंत्र पत्रकारिता का समर्थन करें. आज ही सब्सक्राइब करें."
              : "Independent media plays a critical role in sustaining democracy, telling stories that need to be told and asking questions that demand answers. Support independent journalism."}
          </p>
          <button styleName="pay-btn">
            <Link href="/subscription?ref=homepage-subscription-banner">
              <span>{isHindi ? "सब्सक्राइब करें" : "Subscribe Now"}</span>
            </Link>
          </button>
        </div>
      </div>
      <div styleName="cancel-btn-div">
        <button styleName="cancel-btn" onClick={() => setToShowPopup("closed")}>
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

SubscriptionAppealBanner.propTypes = {
  setToShowPopup: PropTypes.func
};

export { SubscriptionAppealBanner };
